<div class="popup-header">Update Roles</div>
<br>
<div mat-dialog-content>
  <mat-selection-list #list [(ngModel)]="selectedOptions" (ngModelChange)="onNgModelChange($event)">
    <mat-list-option *ngFor="let role of access" [value]="role">
      {{role | titlecase}}
    </mat-list-option>
  </mat-selection-list>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="onNoClick()">Close</button>
  <button class="theme-button" type="button" [mat-dialog-close]="selectedOption" mat-raised-button>Save
  </button>
</div>
